import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetProductQuery } from "../../../Store/Builder/schedule.api";
import showToast from "../../Hooks/toast";

const useGetProductApi = (job_id = '') => {
  const [options, setOptions] = useState([]);
  const provider_id = useSelector((state) => state.rootReducer.techsbookSlice.userData?.provider_id);

  const { data, isError, error } = useGetProductQuery({provider_id, job_id})

  useEffect(() => {
    if(provider_id) {
      showToast(error?.data?.message, "error");
    }
  }, [error])

  useEffect(() => {
    if (data) {
      let a = data?.map((option) => ({
        value: option?.id,
        label: option?.name,
        image: option?.image,
      }));

      setOptions(a);
    }
  }, [data]);
  return {
    options,
  };
};

export default useGetProductApi;
